// Routes owned by the Employee module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const employeePaths = {
    employeesManage: '/employees',
    departmentDetail: '/employees/departments/:id',
    employeeCreate: '/employees/new',
    employeeUpdate: '/employees/:id/update',
    employeeUpdateAdvanced: '/employees/:id/update-advanced',
    // Unreferenced: no paths.* caller; route is live (/employees/:id/identity).
    employeeUpdateIdentity: '/employees/:id/identity',
} as const
